module.exports = __webpack_public_path__ + "static/button-hudlvoice-dont-422714b6a30f7ac50557341ede71f366.png";